import { consoleColors, consoleHelper } from '@utils/genUtils'
import type { ISiteContextState } from './index'

export enum ISiteTypes {
  MODAL_OPEN = 'MODAL_OPEN',
  MODAL_CLOSE = 'MODAL_CLOSE',

  LOGIN_RESOURCE_USER = 'LOGIN_RESOURCE_USER',
  LOGOUT_RESOURCE_USER = 'LOGOUT_RESOURCE_USER',

  SHOW_COMMENTS = 'SHOW_COMMENTS',
  HIDE_COMMENTS = 'HIDE_COMMENTS',
  ADD_COMMENT = 'ADD_COMMENT',
  ADD_COMMENT_REPLY = 'ADD_COMMENT_REPLY',
  FETCH_MORE_COMMENTS = 'FETCH_MORE_COMMENTS',

  UPDATE_BREAKPOINT = 'UPDATE_BREAKPOINT',
  TOGGLE_MOBILE_NAV = 'TOGGLE_MOBILE_NAV',
}

export type ISiteAction = any
export const useSiteReducer = (state: ISiteContextState, action: ISiteAction): ISiteContextState => {
  consoleHelper('site reducer action', action, 'useSiteReducer()' , {bg: consoleColors.yellow, text: "#000"})
  switch (action.type) {

    default: {
      // throw new Error(`Unhandled action type: ${action.type}`)
      return state
    }
  }
}
